import Component from '@glimmer/component';

import type { BoardPreviewMap } from 'webapp-types';

import CommonShareLinkComponent from 'webapp/components/common/share/link/index';

import type { BoardLoop } from 'webapp/models-custom';
import type Board from 'webapp/models-custom/board';

export interface Args {
	model: Board | BoardLoop;
	previewHash: BoardPreviewMap | undefined;
	isContentShown: boolean;
	trackingOrigin: string; // TrackingOriginType from model-manager/board-loops
	onContentChange: () => void;
	onClose: () => void;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class BoardsShareLinkTabComponent extends Component<Args> {
	<template>
		<div class="content2 {{if @isContentShown 'content2--shown'}} shareable-link">

			<CommonShareLinkComponent
				@model={{@model}}
				@previewHash={{@previewHash}}
				@trackingOrigin={{@trackingOrigin}}
				@onContentChange={{@onContentChange}}
			/>

		</div>
	</template>
}
